import React, { useState, useRef, useEffect } from 'react';

export default function SizeFilter() {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);
      // Close dropdown on outside clickclass
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
      <>
    <div className="relative inline-block text-left" ref={dropdownRef}>
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="inline-flex justify-center w-full rounded-md border border-gray-300 px-2 py-2 text-sm font-medium text-gray-500 hover:text-yellow-500 "
        >
            Size
        <svg
          className="-mr-1 ml-2 h-5 w-5"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 20 20"
          fill="currentColor"
          aria-hidden="true"
        >
          <path fillRule="evenodd" d="M5.23 7.21a.75.75 0 011.06.02L10 10.94l3.71-3.71a.75.75 0 111.06 1.06l-4.25 4.25a.75.75 0 01-1.06 0L5.23 8.27a.75.75 0 01.02-1.06z" clipRule="evenodd" />
        </svg>
      </button>

      {isOpen && (
        <div className="origin-top-right absolute right-0 mt-2 w-30 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 z-10">
          <div className="py-1" style={{ maxHeight: '200px', overflowY: 'auto' }}>
            <button className="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100">100x0</button>
            <button className="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100">100x1</button>
            <button className="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100">100x2</button>
            <button className="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100">100x2</button>
            <button className="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100">100x2</button>
            <button className="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100">100x2</button>
            <button className="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100">100x2</button>
            <button className="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100">100x2</button>
            <button className="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100">100x2</button>
            <button className="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100">100x2</button>
            <button className="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100">100x2</button>
            <button className="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100">100x2</button>
          </div>
        </div>
      )}
    </div>
  </>
  
  );
}
